module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"tooltip":{"last_reception":"最終受信状況:","status_inactive":"12時間以上受信していません","never_received":"まだデータを受信していません","monitoring_point_inactive":"現在休止中です"}},"en":{"tooltip":{"last_reception":"Last received:","status_inactive":"No data received for over 12 hours","never_received":"Never received data","monitoring_point_inactive":"Currently inactive"}}}')
  delete Component.options._Ctor
}
